export default __webpack_public_path__ + "static/media/aurum-contentSecurity.da054cbd.svg";